import React from 'react';
import { Box } from '@mui/material';

interface FloatingBannerStackProps {
  children: React.ReactNode;
}

/**
 * Container component for stacking multiple floating banners vertically.
 * 
 * Banners are stacked from bottom to top with automatic spacing.
 * The container is fixed at the bottom center of the viewport.
 */
const FloatingBannerStack: React.FC<FloatingBannerStackProps> = ({ children }) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 20,
        left: 0,
        right: 0,
        display: 'flex',
        flexDirection: 'column-reverse',
        alignItems: 'center',
        gap: 2,
        zIndex: 1400,
        pointerEvents: 'none',
        '& > *': {
          pointerEvents: 'auto',
        },
      }}
    >
      {children}
    </Box>
  );
};

export default FloatingBannerStack;

